// extracted by mini-css-extract-plugin
module.exports = {"root":"ClientCreditCards_root__2hTy-","cards":"ClientCreditCards_cards__ujjwC","empty":"ClientCreditCards_empty__1s564"};